import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import customLookupReducerFactory from './customLookupReducerFactory';
import dependentLookupReducerFactory from './dependentLookupReducerFactory';

/**
 *  For the query passed in action.query, determine if any filters were set that are relevant to
 *  the set of relatedFilterEntityNames
 */
const applyRelatedFiltersAndUpdateQuery = (state, action, relatedFilterEntityNames) => {
  const pendingFilters = _objectSpread({}, state.indexQuery.pendingFilters);
  if (action.query.filters) {
    const filterKeys = Object.keys(action.query.filters);
    filterKeys.forEach(relatedFilterEntityName => {
      if (relatedFilterEntityNames.indexOf(relatedFilterEntityName) !== -1) {
        pendingFilters[relatedFilterEntityName] = action.query.filters[relatedFilterEntityName];
      }
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    indexQuery: _objectSpread(_objectSpread({}, state.indexQuery), {}, {
      pendingFilters
    })
  });
};
const dependentFilterReducerFactory = (entity, baseEntity, indexQueryFragment, queryVariables, indexConstant) => {
  let lookupReducers = null;
  // no dependent lookup management required, usually because the lookup entity is not updateable
  // from client code (i.e., CSV-driven values)
  if (!baseEntity || entity === baseEntity) {
    lookupReducers = customLookupReducerFactory(entity, indexQueryFragment);
  } else {
    lookupReducers = dependentLookupReducerFactory(entity, baseEntity, indexQueryFragment);
  }
  const dependentFilterIndexSuccess = (state, action) => applyRelatedFiltersAndUpdateQuery(state, action, queryVariables);
  const reducers = _objectSpread(_objectSpread({}, lookupReducers.reducers), {}, {
    [indexConstant]: dependentFilterIndexSuccess
  });

  // note that the returned object is intended for composition and client code will need to call
  // `applyReducers(reducers, state)` to get an expected redux reducer
  return {
    reducers,
    initState: lookupReducers.initState
  };
};
export default dependentFilterReducerFactory;